<template>
  <div class="wrap bg-white">

    <!--Add New Folder-->
    <el-dialog title="Tạo thư mục mới" :visible.sync="addFolderVisible" width="40%" @close = "resetCreateFolder()">
      <div class="p-3" style="  border: 1px #A3A7AB52 solid;border-radius: 4px;">
        <p class="fw-semibold font-size-14">
          Tên thư mục
          <span class="text-danger">*</span>
        </p>
        <el-input placeholder="Tối đa 50 ký tự" :maxlength="50" v-model="folder.name"></el-input>
        <div class="mt-3 d-flex justify-content-between align-items-center">
          <span class="fw-semibold font-size-14">Tải lên tệp tin</span>
          <el-upload
            class="upload-demo"
            action="#"
            :headers="getUploadHeader()"
            multiple
            :on-change="fileChanged"
            :file-list="fileList"
            :auto-upload="false"
            :show-file-list="false"
            >
            <div class="d-flex">
              <el-input class="input" placeholder="Chọn tệp ..." readonly=""></el-input>
              <el-button class="upload-btn" size="small" type="#EAECF2">Tìm</el-button>
            </div>
          </el-upload>
        </div>
        <div class="count-file mt-4 d-flex align-items-center" v-if="fileList.length > 0">
          <IconV2 
              slot="prefix"
              color = "primary"
              name = "v2-check"/>
          <p class="mb-0 font-size-14">Đã chọn <span class="text-blue fw-bold">{{ fileList.length }}</span> tệp tin mới để tải lên</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="resetCreateFolder()">Huỷ</el-button>
          <el-button size="medium" type="primary" plain @click="createFolder(true)">Lưu & tiếp tục tạo</el-button>
          <el-button size="medium" type="primary" @click="createFolder(false)">Lưu</el-button>
        </span>
    </el-dialog>

    <!--Add To Folder-->
    <el-dialog title="Thêm vào thư mục" :visible.sync="addToFolder"
       width="40%">
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <span class="font-size-16 fw-semibold">Chọn thư mục để thêm vào</span>
        <div class="search-input d-flex align-item-center me-2">
          <IconV2
            slot="prefix"
            color = "grey"
            name="v2-search" />
          <el-input class="me-2" size="medium" style="width: 250px;border: none;" v-model="searchFolderKey" @input="searchFolder()"  placeholder="Tìm kiếm thư mục" />
        </div>
      </div>
      <div style="padding-right: 10px;max-height: 350px; overflow-y: scroll;">
        <p class="text-center mt-2" v-if="listFolder.length == 0">Không có thư mục nào được tìm thấy</p>
        <div v-else class="w-100 mx-0 p-2 mb-2 " 
          style=" border: 1px #d9d9d9 solid;border-radius: 4px"
          v-for="folder in listFolder" :key="folder.id">
          <el-radio class="d-flex align-items-center" v-model="seletedFolder" :label="folder.id">
            <div class="d-flex align-items-center gap-4">
              <img src="/assets/icon/folder 2.png" alt="Folder icon" />
              <span>{{ folder.name }}</span>
            </div>
          </el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="closeDialogAddToFolder()">Huỷ</el-button>
          <el-button size="medium" type="primary" @click="addDocToFolder(seletedFolder)">Lưu</el-button>
        </span>
    </el-dialog>


    <!--Header-->
    <div class="d-flex justify-content-between align-items-center mt-3 mb-2 mx-4" v-if="!viewImages">
      <div class="d-flex align-item-center">
        <div style="line-height: 32px" class="font-size-18 fw-bold me-2">Thư viện</div>
        <el-select class="option" v-model="accountId" @change="changeShop()" filterable default-first-option
            style="width: 150px">
            <el-option label="Tất cả tài khoản"
                      :value="0"></el-option>
            <el-option v-for="account in app.accounts" :key="account.accountId" :label="account.swName || account.displayName" :value="account.accountId">
            </el-option>
          </el-select>
      </div>
      <div class="d-flex align-items-center gap-2">
        <div class="group-btn font-size-14 d-flex align-items-center gap-2"  v-if="count > 0" >
          <div class="selected d-flex align-items-center gap-2">
            <IconV2 
              size ='lg'
              slot="prefix"
              color = "primary"
              name = "fa-solid fa-square-check"/>
            <span>Đã chọn {{ count }}</span>
          </div>
          <div @click="handleChangeFavourite()" v-if="isDisplay">
            <span>{{ isFavourite() ? 'Bỏ yêu thích' : 'Yêu thích' }}</span>
          </div>
          <div class="d-flex align-items-center gap-2" v-if="selectImages.length > 0">
            <span @click="openDialogAddToFolder()">Thêm vào thư mục</span>
            <el-tooltip class="item" effect="dark" content="Thêm tài liệu được chọn vào thư mục" placement="top" visible-arrow="false">
              <div>
                <IconV2 
                slot="prefix"
                color="primary"
                name="v2-info2" />
              </div>
            </el-tooltip>
          </div>
          <span @click="handleDelete()">Xóa</span>
        </div>
        <div class="search-create d-flex">
          <div class="search-input d-flex align-item-center me-2">
            <IconV2
              slot="prefix"
              color = "grey"
              name="v2-search" />
            <el-input class="me-2" size="medium" style="width: 250px;border: none;" v-model = "searchKey" @input="searchFolderAndImage()"  placeholder="Tìm kiếm thư mục, ảnh" />
          </div>
          <el-button class="" size="medium" type="primary" @click="createNewFolder()">
            <div class="w-100 d-flex align-items-center gap-2">
              <IconV2
              slot="prefix"
              color = "primary"
              name="v2-add" />
              Tạo thư mục mới
            </div>
          </el-button>
        </div>
      </div>
     
    </div>

    <!--Display Folder And Image-->
    <div class="mx-4 folder" type="" v-if="!viewImages">
      <p class="font-size-16 text-grey list-folder" v-if="folders.length == 0" ref="listFolder">
        Chưa có thư mục nào. 
        <span class="text-blue link" @click="createNewFolder()">Bấm vào đây</span> 
        để tạo thư mục mới
      </p>
      <div v-else class="w-100 mb-3 mx-0 container list-folder" style="max-width: 100%" ref="listFolderContainer">
        <div class="row" >
          <p class="font-size-16 text-grey mb-0" v-if="foldersShow.length == 0">Không có thư mục nào được tìm thấy</p>
          <div v-else class="col-xxl-2 col-3 mb-2 px-2" v-for="folder in foldersShow" :key="folder.id">
            <el-button size="medium" class="w-100 px-2" type="" >
              <div class="w-100 d-flex align-items-center justify-content-between">
                <div class="text-folder flex-grow-1 d-flex align-items-center gap-2" 
                  @click="clickFolder(folder)">
                  <img src="/assets/icon/folder 2.png" />
                  <p class="name mb-0">{{ folder.name }}</p>
                </div>
                <div class="d-flex gap-2 align-items-center">
                    <div v-if="folder.favourite">
                      <IconV2
                        slot="prefix"
                        color = "#FFCC00"
                        name="fa-solid fa-star" />
                    </div>
                    <el-checkbox
                      :value="isFolderSelected(folder)" 
                      @change="toggleFolderSelect(folder)"
                      class="mt-1"
                    ></el-checkbox>
                </div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
      <div class="divider-custom mb-3" />
      <div class="mt-3 w-100">
        <div class="d-flex justify-content-between header-image" ref="headerImage">
          <span class="text-header">Tài liệu ngoài thư mục</span>
          <div class="d-flex align-items-center">
            <div class="group-type d-flex">
              <div :class="{'active' : isSelected === index}" class="d-flex align-items-center gap-2 px-3 py-2" v-for="(type,index) in typeInfo" :key="index" @click="getFileByType(type.value,index)">
                <span>{{ type.name }}</span>
                <div v-if="isSelected === index">
                  <IconV2
                  slot="prefix"
                  color = "primary"
                  name="v2-check" />
                </div>
              </div>
            </div>
            <div class="view-toggle d-flex align-items-center ms-3">
              <div
                class="px-2 py-2 pointer view-toggle-btn"
                :class="{ 'active': viewMode === 'icons' }"
                title="Hiển thị dạng biểu tượng"
                @click="setViewMode('icons')">
                <i class="el-icon-menu"></i>
              </div>
              <div
                class="px-2 py-2 pointer view-toggle-btn"
                :class="{ 'active': viewMode === 'list' }"
                title="Hiển thị dạng danh sách"
                @click="setViewMode('list')">
                <i class="el-icon-tickets"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="container display mt-3 w-100 mx-0" :style="{ maxHeight: remainingHeight + 'px' }" style="max-width: 100%;">
          <div v-if="viewMode === 'icons'" class=" group-upload d-flex flex-wrap">
            <div class="col-xxl-2 col-3 mb-3 px-2">
              <el-upload
                class="uploader w-100 h-100 d-flex align-items-center justify-content-center"
                :action="getUploadUrl(folderId)"
                :headers="getUploadHeader()"
                multiple
                :on-change="fileChanged"
                :on-success="handleUploadSuccess"
                :before-upload="beforeUpload"
                :accept="getAcceptType"
                :file-list="fileList"
                :show-file-list="false">
                <div class="">
                  <img src="/assets/icon/upload.png" alt="img-upload">
                  <p class="text-grey mt-2 mb-0 font-size-13">Kéo thả tệp tin hoặc</p>
                  <p class="text-blue mb-0 font-size-13">bấm để chọn</p>
                </div>
              </el-upload>
            </div>
            <div class="col-xxl-2 col-3 mb-3 px-2" v-for="image in imagesShow" :key="image.id">
              <div class="card h-100 mb-0 d-flex flex-column justify-content-between">
                <div class="favorive" v-if="image.favourite">
                  <IconV2
                    slot="prefix"
                    color = "#FFCC00"
                    name="fa-solid fa-star" />
                </div>
                <FileV2 class="card-image" :type="image.contentType" :id="image.id" :url="image.url" />
                <div>
                  <div class="card-body my-2 mx-1 p-1 d-flex justify-content-between align-items-center">
                    <p class="card-text text-nowrap font-size-14 mb-0">{{ image.fileName }}</p>
                    <el-checkbox
                      :value="selectedImg(image)" size="medium" @input="selecteImg(image)"
                    ></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <el-upload
              class="list-upload-bar mb-2"
              :action="getUploadUrl(folderId)"
              :headers="getUploadHeader()"
              multiple
              drag
              :on-change="fileChanged"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
              :accept="getAcceptType"
              :file-list="fileList"
              :show-file-list="false">
              <div class="d-flex align-items-center justify-content-center gap-2 py-2">
                <img src="/assets/icon/upload.png" alt="img-upload" style="height: 24px" />
                <span class="text-grey font-size-13">Kéo thả tệp tin hoặc</span>
                <span class="text-blue font-size-13">bấm để chọn</span>
              </div>
            </el-upload>
            <el-table :data="imagesShow" size="small" stripe class="image-list-table">
              <el-table-column width="56" align="center">
                <template slot-scope="{ row }">
                  <el-checkbox :value="selectedImg(row)" @input="selecteImg(row)" />
                </template>
              </el-table-column>
              <el-table-column width="64" label="">
                <template slot-scope="{ row }">
                  <img class="list-thumb" :src="getRowThumbSrc(row)" loading="lazy" />
                </template>
              </el-table-column>
              <el-table-column label="Tên" min-width="200" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ row.fileName }}</template>
              </el-table-column>
              <el-table-column label="Loại" width="100">
                <template slot-scope="{ row }">{{ getFileExt(row).toUpperCase() }}</template>
              </el-table-column>
              <el-table-column label="Yêu thích" width="100" align="center">
                <template slot-scope="{ row }">
                  <i
                    class="pointer"
                    :class="row.favourite ? 'el-icon-star-on' : 'el-icon-star-off'"
                    :style="{ color: row.favourite ? '#FFCC00' : '#909399', fontSize: '20px' }"
                    @click="toggleImageFavourite(row)" />
                </template>
              </el-table-column>
              <el-table-column label="Ngày tạo" width="160">
                <template slot-scope="{ row }">{{ formatImageDate(row) }}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>


    <!--Display In Folder-->
    <div class="mx-4" v-else>
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex justify-content-between align-items-center my-2 mx-4">
            <div class="d-flex  justify-content-between align-items-center">
              <p class="font-size-16 mb-0  text-grey mx-2 pointer" @click="goBack()">Thư viện /</p>
              <p class="font-size-18 mb-0 fw-semibold flex-grow-1">{{ openFolder.name }}</p> 
            </div>
            <div class="d-flex align-items-center gap-2">
              <div class="group-btn font-size-14 d-flex align-items-center gap-2"  v-if="count > 0" >
                <div class="selected d-flex align-items-center gap-2">
                  <IconV2 
                    size ='lg'
                    slot="prefix"
                    color = "primary"
                    name = "fa-solid fa-square-check"/>
                  <span>Đã chọn {{ count }}</span>
                </div>
                <div @click="handleChangeFavourite()" v-if="isDisplay">
                  <span>{{ isFavourite() ? 'Bỏ yêu thích' : 'Yêu thích' }}</span>
                </div>
                <span @click="handleDelete()">Xóa</span>
              </div>
              <div class="search-create d-flex">
                <div class="search-input d-flex align-item-center">
                  <IconV2
                    slot="prefix"
                    color = "grey"
                    name="v2-search" />
                  <el-input class="me-2" size="medium" style="width: 300px;border: none;" v-model = "searchKey" @input="searchFolderAndImage()" placeholder="Tìm kiếm thư mục, ảnh" />
                </div>
              </div>
            </div>
          </div>
          <div class="mx-4  folder" type="">
            <div class="mt-3 w-100">
              <div class="d-flex justify-content-between">
                <span class="text-header">Danh sách tài liệu</span>
                <div class="d-flex align-items-center">
                  <div class="group-type d-flex">
                    <div :class="{'active' : isSelected === index}" class="d-flex align-items-center gap-2 px-3 py-2" v-for="(type,index) in typeInfo" :key="index" @click="getFileByType(type.value,index)">
                      <span>{{ type.name }}</span>
                      <div v-if="isSelected === index">
                        <IconV2
                        slot="prefix"
                        color = "primary"
                        name="v2-check" />
                      </div>
                    </div>
                  </div>
                  <div class="view-toggle d-flex align-items-center ms-3">
                    <div
                      class="px-2 py-2 pointer view-toggle-btn"
                      :class="{ 'active': viewMode === 'icons' }"
                      title="Hiển thị dạng biểu tượng"
                      @click="setViewMode('icons')">
                      <i class="el-icon-menu"></i>
                    </div>
                    <div
                      class="px-2 py-2 pointer view-toggle-btn"
                      :class="{ 'active': viewMode === 'list' }"
                      title="Hiển thị dạng danh sách"
                      @click="setViewMode('list')">
                      <i class="el-icon-tickets"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container mt-3 display-in-folder w-100 mx-0" style="max-width: 100%">
                <div v-if="viewMode === 'icons'" class=" row group-upload ">
                  <div class="col-xxl-2 col-3 mb-3 px-2">
                    <el-upload
                      class="uploader w-100 h-100 d-flex align-items-center justify-content-center"
                      :action="getUploadUrl(folderId)"
                      :headers="getUploadHeader()"
                      multiple
                      :on-change="fileChanged"
                      :on-success="handleUploadSuccess"
                      :before-upload="beforeUpload"
                      :accept="getAcceptType"
                      :file-list="fileList"
                      :show-file-list="false">
                      <div class="">
                        <img src="/assets/icon/upload.png" alt="img-upload">
                        <p class="text-grey mt-2 mb-0 font-size-13">Kéo thả tệp tin hoặc</p>
                        <p class="text-blue mb-0 font-size-13">bấm để chọn</p>
                      </div>
                    </el-upload>
                  </div>
                  <div class="col-xxl-2 col-3 mb-3 px-2" v-for="image in imagesShow" :key="image.id">
                    <div class="card h-100 mb-0 d-flex flex-column justify-content-between">
                      <div class="favorive" v-if="image.favourite">
                        <IconV2
                          slot="prefix"
                          color = "#FFCC00"
                          name="fa-solid fa-star" />
                      </div>
                      <FileV2 class="card-image" :type="image.contentType" :id="image.id" :url="image.url" />
                      <div class="card-body my-2 mx-1 p-1 d-flex justify-content-between align-items-center">
                        <p class="card-text text-nowrap font-size-14 mb-0">{{ image.fileName }}</p>
                        <el-checkbox
                          :value="selectedImg(image)" size="medium" @input="selecteImg(image)"
                        ></el-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <el-upload
                    class="list-upload-bar mb-2"
                    :action="getUploadUrl(folderId)"
                    :headers="getUploadHeader()"
                    multiple
                    drag
                    :on-change="fileChanged"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload"
                    :accept="getAcceptType"
                    :file-list="fileList"
                    :show-file-list="false">
                    <div class="d-flex align-items-center justify-content-center gap-2 py-2">
                      <img src="/assets/icon/upload.png" alt="img-upload" style="height: 24px" />
                      <span class="text-grey font-size-13">Kéo thả tệp tin hoặc</span>
                      <span class="text-blue font-size-13">bấm để chọn</span>
                    </div>
                  </el-upload>
                  <el-table :data="imagesShow" size="small" stripe class="image-list-table">
                    <el-table-column width="56" align="center">
                      <template slot-scope="{ row }">
                        <el-checkbox :value="selectedImg(row)" @input="selecteImg(row)" />
                      </template>
                    </el-table-column>
                    <el-table-column width="64" label="">
                      <template slot-scope="{ row }">
                        <img class="list-thumb" :src="getRowThumbSrc(row)" loading="lazy" />
                      </template>
                    </el-table-column>
                    <el-table-column label="Tên" min-width="200" show-overflow-tooltip>
                      <template slot-scope="{ row }">{{ row.fileName }}</template>
                    </el-table-column>
                    <el-table-column label="Loại" width="100">
                      <template slot-scope="{ row }">{{ getFileExt(row).toUpperCase() }}</template>
                    </el-table-column>
                    <el-table-column label="Yêu thích" width="100" align="center">
                      <template slot-scope="{ row }">
                        <i
                          class="pointer"
                          :class="row.favourite ? 'el-icon-star-on' : 'el-icon-star-off'"
                          :style="{ color: row.favourite ? '#FFCC00' : '#909399', fontSize: '20px' }"
                          @click="toggleImageFavourite(row)" />
                      </template>
                    </el-table-column>
                    <el-table-column label="Ngày tạo" width="160">
                      <template slot-scope="{ row }">{{ formatImageDate(row) }}</template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Config from "../lib/Config";
import IconV2 from './common/IconV2.vue';
import FileV2 from "./imageLibSetting/FileV2.vue";

export default {
  components: { FileV2,IconV2 },
  data() {
    return {
      accountId: "",
      folderId: 0,
      previousFolderId: null,
      folders: [],
      images: [],
      selectedFolders: [],
      addFolderVisible: false,
      addToFolder : false,
      folder: {
        id: 0,
        name: ""
      },
      openFolder: 0,
      viewImages: false,
      fileList: [],
      selectImages: [],
      fileNameList: [],
      isSelected : 0,
      isDisplay : false,
      count : 0,
      searchKey : "",
      searchFolderKey : "",
      foldersShow : [],
      imagesShow : [],
      listFolder : [],
      typeInfo : [
        {
          name : 'Tất cả',
          value : ['']
        },
        {
          name : 'Ảnh & video',
          value : ['jpg', 'jpeg', 'pjpeg', 'pjp', 'png', 'svg','m4v', 'mp4', 'avi', 'mkv', 'wmv', 'flv', 'mov', '3gp', '3g2']
        },
        {
          name : 'PDFs',
          value : ['pdf']
        },
        {
          name : 'Docs',
          value : ['doc', 'docx', 'txt', 'odt', 'tex', 'xml', 'html']
        },
        {
          name : 'Excel',
          value : ['xlsx', 'xls', 'xlsm', 'xlsb']
        },
        {
          name : 'Khác',
          value : ['other']
        },
      ],
      screenHeight: 0,
      listFolderHeight: 0,
      headerImageHeight: 0,
      remainingHeight: 0,
      seletedFolder : '',
      isNotificationShown: false,
      maxFileSize: 200 * 1024 * 1024,
      viewMode: (localStorage.getItem("imageLibraryViewMode") === "list") ? "list" : "icons",
    };
  },
  methods: {
    setViewMode(mode) {
      this.viewMode = mode;
    },
    getFileExt(image) {
      if (!image || !image.fileName) return "";
      const dot = image.fileName.lastIndexOf(".");
      return dot >= 0 ? image.fileName.substring(dot + 1).toLowerCase() : "";
    },
    formatImageDate(image) {
      const raw = image && (image.createAt || image.createDate || image.uploadDate || image.created_at);
      if (!raw) return "-";
      try {
        return this.moment(raw).format("DD/MM/YYYY HH:mm");
      } catch (e) {
        return "-";
      }
    },
    getRowThumbSrc(image) {
      if (image && image.contentType && image.contentType.toLowerCase().includes("image")) {
        return image.url;
      }
      const ext = this.getFileExt(image);
      switch (ext) {
        case "m4v": case "mp4": case "avi": case "mkv": case "wmv":
        case "flv": case "mov": case "3gp": case "3g2":
          return "/assets/icon/icon-file-video.svg";
        case "pdf":
          return "/assets/icon/icon-file-pdf.svg";
        case "zip":
          return "/assets/icon/icon-file-zip.svg";
        case "doc": case "docx": case "txt": case "odt": case "tex":
        case "xml": case "html":
          return "/assets/icon/icon-file-doc.svg";
        case "xlsx": case "xls": case "xlsm": case "xlsb":
          return "/assets/icon/icon-file-excel.svg";
        default:
          return "/assets/icon/icon-file-doc.svg";
      }
    },
    async toggleImageFavourite(image) {
      const newVal = !image.favourite;
      try {
        await this.$http.put("/api/v2/image/change?accountId=" + this.accountId, [
          { id: image.id, favourite: newVal }
        ]);
        this.$set(image, "favourite", newVal);
      } catch (e) {
        this.alert("error", "Cập nhật thất bại");
      }
    },
    getFileByType(type, index) {
      this.isSelected = index;
      if (type.length === 0 || type.includes('')) {
        this.imagesShow = this.images;
      } else if (type.includes('other')) {
        const excludedTypes = ['jpg', 'jpeg', 'pjpeg', 'pjp', 'png', 'svg','m4v', 'mp4', 'avi', 'mkv', 'wmv', 'flv', 'mov', '3gp', '3g2','pdf','doc', 'docx', 'txt', 'odt', 'tex', 'xml', 'html','xlsx', 'xls', 'xlsm', 'xlsb'];
        this.imagesShow = this.images.filter(image => {
          return !excludedTypes.some(t => image.fileName.substring(image.fileName.lastIndexOf('.') + 1).toLowerCase().includes(t));
        });
      } else {
        this.imagesShow = this.images.filter(image => {
          return type.some(t => image.fileName.substring(image.fileName.lastIndexOf('.') + 1).toLowerCase().includes(t.toLowerCase()));
        });
      }
    },
    resetCreateFolder (){
      this.addFolderVisible = false;
      this.folder = {};
      this.fileList = [];
    },
    async fetchFolders() {
      this.folders = [];
      await this.$http.get("/api/v2/folder?accountId=" + this.accountId)
        .then((response) => {
          this.folders = response.data;
          if(this.folders.length){
            this.foldersShow = this.folders;
            this.listFolder = this.folders;
            this.seletedFolder = this.foldersShow[0].id
          }
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },
    isFolderSelected(folder) {
      return this.selectedFolders.includes(folder);
    },
    toggleFolderSelect(folder) {
      let index = this.selectedFolders.indexOf(folder);
      if (index > -1) {
        this.selectedFolders.splice(index, 1);
      } else {
        this.selectedFolders.push(folder);
      }
      console.log(this.selectedFolders);
    },
    async changeFavouriteFolder() {
      const allSameFavouriteStatus = this.selectedFolders.every(folder => folder.favourite === this.selectedFolders[0].favourite);

      if (!allSameFavouriteStatus) {
        this.alert('error','Tất cả các thư mục phải có cùng trạng thái');
        return;
      }

      let path = "/api/v2/folder/change?accountId=" + this.accountId;

      let request = this.selectedFolders.map(folder => ({
        id: folder.id,
        favourite: folder.favourite
      }));

      try {
        await this.$http.put(path, request);
        this.selectedFolders = [];

        await this.fetchFolders();
        this.alert('success','Cập nhật thành công');
      } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        this.alert("error",'Lỗi');
      }
    },
    createNewFolder() {
      this.fileList = [];
      this.folder = {
        id: 0,
        name: ""
      };
      this.addFolderVisible = true;
    },
    async createFolder(continueCreating) {
      let path = "/api/folder";

      if (this.folder.name.trim().length === 0) {
        return this.alertError("Bạn chưa nhập tên thư mục");
      }

      let request = {
        accountId: this.accountId,
        id: this.folder.id,
        name: this.folder.name
      };

      try {
        const response = await this.$http.post(path, request);
        const folderId = response.data.id;

        await this.uploadFiles(folderId);

        if(!continueCreating) {
          this.addFolderVisible = false;
        }

        if (continueCreating) {
          this.createNewFolder();
          this.addFolderVisible = true;
        }
        
        this.fetchFolders();
        this.alert("success", "Tạo thư mục thành công");

      } catch (ex) {
        if (ex.error?.message.includes("dupplicate")) {
          this.alert("error", "Tên thư mục đã tồn tại");
        }
        else if(ex.error?.message.includes('No Manage Permission')){
          return this.alert("error", "Bạn chưa có quyền cài đặt và chỉnh sửa");
        } 
        else {
          this.alert("error", "Có lỗi xảy ra");
        }
      }
    },

    async uploadFiles(folderId) {
      const uploadUrl = this.getUploadUrl(folderId);
      const headers = this.getUploadHeader();

      for (const file of this.fileList) {
        const formData = new FormData();
        formData.append('file', file.raw);
        try {
          await this.$http.post(uploadUrl, formData, { headers });          
        } catch (error) {
          console.error('Error uploading file:', error);
          this.alert("error", "Tải lên thất bại");
        }
      }
    },
    getUploadUrl(folderId) { 
      let HOST = "";
      if (Config.DEV) {
        HOST = Config.HOST;
      } else {
        HOST = "https://zalo.salework.net";
      }
      return HOST + "/api/v2/image?accountId=" + this.accountId + "&folderId=" + folderId;
    },
    getUploadHeader() {
      let userToken = localStorage.getItem("userToken");

      return {
        Authorization: "Bearer " + userToken
      };
    },
    fileChanged(file, fileList) {
      this.fileList = fileList;   
    },
    async handleUploadSuccess() {
      this.selectImages = [];
      if (!this.isNotificationShown) {
        this.$message({
          message: 'Hệ thống đang xử lý, xin vui lòng chờ và không thoát trang',
          type: 'warning'
        });
        this.isNotificationShown = true;
      }     
      await this.fetchImages(this.folderId)
        .then(() => {
          this.fileList.splice(0, this.fileList.length);
          this.alert('success', `Tải lên thành công`);
          this.getFileByType(this.typeInfo[this.isSelected].value, this.isSelected);
          this.isNotificationShown = false;
        }); 
    },
    beforeUpload(file) {
      if (file.size > this.maxFileSize) {
        this.alert('error', `File ${file.name} tải lên phải nhỏ hơn 200Mb`);
        return false;
      }
      return true;
    },
    changeShop() {
      this.isSelected = 0;
      this.searchKey = "";
      this.folderId = 0;
      this.fileList = [];
      this.selectImages = [];
      this.viewImages = false;
      this.fetchFolders();
    },
    deleteFolder() {
      this.$confirm("Bạn chắc chắn muốn xoá thư mục này?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          this.$http.delete("/api/v2/folder?accountId=" + this.accountId + "&ids=" + this.selectedFolders.map((folder) => folder.id))
            .then(() => {
              this.alert("success", "Đã xoá thư mục");
              this.fetchFolders();
              this.selectedFolders = []
            })
            .catch(() => {
              this.alert("error", "Có lỗi xảy ra");
            });
        })
        .catch(() => {
        });
    },
    clickFolder(folder) {
      this.isSelected = 0;
      this.searchKey = "";
      this.selectImages = [];
      this.selectedFolders = [];
      this.imagesShow = [];
      this.openFolder = folder;
      this.folderId = this.openFolder.id;
      this.viewImages = true;
      this.fetchImages(this.folderId);
    },
    goBack() {
      this.isSelected = 0;
      this.searchKey = "";
      this.folderId = 0;
      this.fileList = [];
      this.imagesShow = [];
      this.selectImages = [];
      this.viewImages = false;
      this.fetchImages(this.folderId);
      this.fetchFolders();
    },
    async fetchImages(folderId) {
      this.images = [];
      await this.$http.get("/api/v2/image?accountId=" + this.accountId + "&folderId=" + folderId)
        .then(response => {
          this.images = response.data.sort((a, b) => new Date(b.createAt) - new Date(a.createAt));
          this.imagesShow = this.images;
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },
    imageUploaded() {
      this.alert("success", "Upload thành công");
      this.fetchImages();
      this.getFiles();
    },
    imageUploadFailed(ex) {
      if (ex.toString().includes("not accept")) {
        return this.alert("error", "File tải lên quá lớn");
      }
      this.alert("error", "Có lỗi xảy ra");
    },
    async getNameFile(image) {
      return await this.$http.get("/api/v2/image/" + image).then(resp => {

        return resp;
      });

    },
    selectedImg(image) {
      let index = this.selectImages.indexOf(image);
      if (index > -1) {
        return true;
      }
      return false;
    },
    selecteImg(image) {
      let index = this.selectImages.indexOf(image);
      if (index > -1) {
        this.selectImages.splice(index, 1);
      } else {
        this.selectImages.push(image);
      }
    },
    cancelDeleteImg() {
      this.selectImages = [];
    },
    deleteImage() {
      this.$confirm("Bạn chắc chắn muốn xóa?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          this.$http.delete("/api/v2/image?accountId=" + this.accountId + "&folderId=" + this.folderId + "&ids=" + this.selectImages.map((image) => image.id))
            .then(() => {
              this.fetchImages(this.folderId)
              .then(() => {
                  this.cancelDeleteImg();
                  this.getFileByType(this.typeInfo[this.isSelected].value, this.isSelected);
                  this.alert("success", "Đã xoá ");
              });
            })
            .catch(() => {
              this.alert("error", "Có lỗi xảy ra");
            });
        })
        .catch(() => {
        });
    },
    getFiles() {
      this.fileNameList = [];
      this.$http.get("/api/image/file?accountId=" + this.accountId + "&folderId=" + this.openFolder.id)
        .then(response => {
          this.fileNameList = response.data;
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },
    isFavourite() {
      if (this.selectedFolders.length > 0) {
        const allFavourite = this.selectedFolders.every(folder => folder.favourite === true);
        return allFavourite;
      }
      else if (this.selectImages.length > 0) {
        const allFavourite = this.selectImages.every(image => image.favourite === true);
        return allFavourite;
      }
    },
    checkFavourite() {
      this.count = 0;
      if (this.selectedFolders.length > 0 && this.selectImages.length > 0) {
        this.isDisplay = false;
        this.count = 0;
      }
      else if (this.selectedFolders.length > 0) {
        this.count = this.selectedFolders.length;
        const allSameFolder = this.selectedFolders.every(folder => folder.favourite === this.selectedFolders[0].favourite);
        this.isDisplay = allSameFolder;
      }
      else if (this.selectImages.length > 0) {
        this.count = this.selectImages.length;
        const allSameImage = this.selectImages.every(image => image.favourite === this.selectImages[0].favourite);
        this.isDisplay = allSameImage;
      }
      else {
        this.isDisplay = false;
      }
    },
    async changeFavouriteImage() {
      const allSameFavouriteStatus = this.selectImages.every(image => image.favourite === this.selectImages[0].favourite);

      if (!allSameFavouriteStatus) {
        this.alert('error','Tất cả các ảnh phải có cùng trạng thái');
        return;
      }

      let path = "/api/v2/image/change?accountId=" + this.accountId;

      let request = this.selectImages.map(image => ({
        id: image.id,
        favourite: image.favourite
      }));

      try {
        await this.$http.put(path, request);

        await this.fetchImages(this.folderId)
        .then(() => {
          this.getFileByType(this.typeInfo[this.isSelected].value, this.isSelected);
          this.selectImages = [];
        });
        this.alert('success','Cập nhật thành công');
      } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        this.alert("error",'Lỗi');
      }
    },
    handleChangeFavourite() {
      if (this.selectedFolders.length > 0) {
        this.changeFavouriteFolder();
      } else if (this.selectImages.length > 0) {
        this.changeFavouriteImage();
      } else {
        this.alert('error', 'Không có ảnh hoặc thư mục nào được chọn');
      }
    },
    handleDelete() {
      if (this.selectedFolders.length > 0) {
        this.deleteFolder();
      } else if (this.selectImages.length > 0) {
        this.deleteImage();
      }
    },
    async addDocToFolder(folderId){
      let path = "/api/v2/image/addToFolder?accountId=" + this.accountId + "&folderId=" + folderId + "&ids=" + this.selectImages.map((image) => image.id);

      try {
        await this.$http.put(path);
        this.selectImages = [];
        this.searchFolderKey = '';
        await this.fetchImages(this.folderId);
        this.addToFolder = false;
        this.alert('success','Thêm vào thư mục thành công');
      } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        this.alert("error",'Lỗi');
      }
    },
    openDialogAddToFolder  (){
      this.addToFolder = true;
      this.searchFolderKey = '';
      this.listFolder = this.folders;
      this.seletedFolder = this.listFolder[0].id;
    },
    closeDialogAddToFolder (){
      this.addToFolder = false;
      this.searchFolderKey = '';
    },
    searchFolderAndImage () {
      if (this.searchKey.length > 0) {
        this.foldersShow = this.folders.filter(p => p.name.toLowerCase().includes(this.searchKey.toLowerCase()));
        this.imagesShow = this.images.filter(p => p.fileName.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.foldersShow = this.folders;
        this.imagesShow = this.images;
      }
    },
    searchFolder () {
      if (this.searchFolderKey.length > 0) {
        this.listFolder = this.folders.filter(p => p.name.toLowerCase().includes(this.searchFolderKey.toLowerCase()));
      } else {
        this.listFolder = this.folders;
      }
    },
    calculateHeights() {
      this.screenHeight = window.innerHeight;
      this.listFolderHeight = this.$refs.listFolderContainer ? this.$refs.listFolderContainer.clientHeight : 0;
      this.headerImageHeight = this.$refs.headerImage ? this.$refs.headerImage.clientHeight : 0;
      this.remainingHeight = this.screenHeight - (this.listFolderHeight + this.headerImageHeight + 240);
    }
  },
  computed: {
    getAcceptType() {
      const fileTypes = this.typeInfo[this.isSelected].value;

      if (fileTypes.length === 0 || fileTypes[0] === '') {
        return '*/*';
      }else if(fileTypes.includes('other')){
        return '*/*';
      }
      return fileTypes.map(type => `.${type}`).join(',');
    }
  },
  watch: {
    viewMode(val) {
      localStorage.setItem("imageLibraryViewMode", val);
    },
    selectImages: {
      handler() {
        this.checkFavourite();
      },
      deep: true
    },
    selectedFolders: {
      handler() {
        this.checkFavourite();
      },
      deep: true
    }
  },
  created() {
    if (this.app.accounts.length > 0) {
      this.accountId = 0;
      this.fetchFolders();
      this.fetchImages(this.folderId);
    }
  },
  updated() {
    this.calculateHeights();
    window.addEventListener('resize', this.calculateHeights);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateHeights);
  },
};
</script>

<style scoped>
.wrap {
  font-family: Arial, Helvetica, sans-serif ;
}

.count-file{
  background-color: #F4F5F9;
  padding: 8px 12px;
  border-radius: 4px;
}

.group-btn {
  background-color: #EAECF2;
  padding: 10px 12px;
  border-radius: 4px;
}

.group-btn > * {
  border-right: 1px #C5C8D3AD solid;
  padding-right: 8px;
  cursor: pointer;
}

.group-btn > :first-child {
  cursor: default;
}

.group-btn > span:last-child {
  border: none;
  color: #CF4547;
}

.selected{
  color: #1769D7;
}

.folder{
  padding: 16px 12px;
  border: 1px #A3A7AB52 solid;
  border-radius: 4px 4px 0px 0px;
}
.text-header{
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1%;
  color: #42444D;
}
.group-type {
  border: 1px #DCDFE9 solid;
  border-radius: 4px;
}
.group-type > *  {
  border-right: 1px #C5C8D3AD solid;
  cursor: pointer;
}
.group-type > :last-child {
  border: none;
}
.active{
  color : #0A58C0;
  background-color: #E1EDFD;
}

.list-folder {
  max-height: 40vh;
  overflow-y: scroll;
}

.display {
  overflow-y: scroll;
}

.view-toggle {
  border: 1px #DCDFE9 solid;
  border-radius: 4px;
}
.view-toggle-btn {
  color: #696B72;
  line-height: 1;
  font-size: 16px;
}
.view-toggle-btn + .view-toggle-btn {
  border-left: 1px #C5C8D3AD solid;
}
.view-toggle-btn.active {
  color: #0A58C0;
  background-color: #E1EDFD;
}
.image-list-table .list-thumb {
  width: 40px;
  height: 40px;
  object-fit: contain;
  background: #F4F5F9;
  border-radius: 4px;
  display: block;
}
.list-upload-bar >>> .el-upload {
  display: block;
  width: 100%;
}
.list-upload-bar >>> .el-upload-dragger {
  width: 100%;
  height: auto;
  padding: 4px 8px;
  border: 1px dashed #C5C8D3AD;
  border-radius: 4px;
  background: #FAFAFA;
}

.display-in-folder{
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.link{
  text-decoration: underline;
  cursor: pointer;
}

.uploader{
  width: max-content;
  padding: 32px 48px;
  border: 1px  #d9d9d9 dashed;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader .el-upload:hover {
  border-color: #409EFF;
}
.card{
  position: relative;
  border: 1px #d9d9d9 solid;
  overflow: hidden;
}
.favorive{
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
}
.card-image{
  border-radius: 4px 4px 0 0;
  height: 200px;
  max-width: 100%;
  object-fit: cover;
  overflow: hidden;
}

.text-folder{
  max-width: calc(100% - 50px);
}

.name{
  max-width: 100%;
  color: #696B72;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 1%;
  white-space: nowrap; /* Không xuống dòng */
  overflow: hidden; /* Ẩn phần văn bản tràn */
  text-overflow: ellipsis;
}

.card-text{
  max-width: 250px;
  color: #696B72;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 1%;
  white-space: nowrap; /* Không xuống dòng */
  overflow: hidden; /* Ẩn phần văn bản tràn */
  text-overflow: ellipsis;
}
.input ::v-deep .el-input__inner {
  cursor: pointer;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
}

.upload-btn{
  padding: 2px 32px;
  border-radius: 0px 4px 4px 0px;
  background-color: #EAECF2;
}

.skeleton-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border: 1px #d9d9d9 solid;
  overflow: hidden;
  border-radius: 4px;
}

.skeleton-image,
.skeleton-text,
.skeleton-checkbox {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-image {
  width: 100%;
  height: 200px;
}

.skeleton-text {
  height: 20px;
  width: 60%;
  margin: 10px;
}

.skeleton-checkbox {
  height: 20px;
  width: 20px;
  margin: 10px;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}


</style>
